<div class="plus-minus-container body-m">
  <app-button
    (click)="decreaseQuantity(quantity)"
    [disabled]="disabled() || quantity <= minQuantity"
    [icon]="'remove_circle'"
    [size]="'small'"
    [type]="'tertiary'"
    data-testid="button-minus"></app-button>
  <input
    [(ngModel)]="quantity"
    [disabled]="disabled()"
    [min]="minQuantity"
    class="plus-minus-input"
    readonly="readonly"
    type="number" />
  <app-button
    (click)="increaseQuantity(quantity)"
    [disabled]="isDisabled()"
    [icon]="'add_circle'"
    [size]="'small'"
    [type]="'tertiary'"
    data-testid="button-plus"></app-button>
</div>
